/* eslint-disable */
function filter(source, query, fields) {
  if (!source) {
    return [];
  }
  if (!query || !Array.isArray(source)) {
    return source;
  }

  const terms = query.split(' ');
  const results = source.filter((item) => {
    fields = fields || Object.keys(item);
    if (item.id) {
      item._idhash = `#${item.id}#`;
    }
    let score = 0;
    terms.forEach((term) => {
      let includes = false;
      if (term.startsWith('#')) {
        if (item._idhash.includes(term)) {
          includes = true;
        }
      }
      fields.forEach((field) => {
        if (item[field] && item[field].toString().toLowerCase().includes(term.toLowerCase())) {
          includes = true;
        }
      });
      includes && (score += term.length);
    });
    item._score = score;
    return (score > 0);
  }).sort((a, b) => (b._score - a._score)).map((item) => {
    delete item._score;
    delete item._idhash;
    return item;
  });
  return results;
}

export default filter;
